import classNames from 'classnames'
import React from 'react'

import { Loader } from 'core-components/library/loader'

import styles from './APLLoadingPage.module.scss'

export const APLLoadingPage = () => (
  <div className={classNames(styles.content, styles.centered)}>
    <Loader />
  </div>
)
